module.exports = __webpack_public_path__ + "static/netlify-05-f68fe3d25fd09b42507902eef2da8dd1.png";